import Tabs, { TabItem } from "../../components/tabs";
import useQueryParams from "../../hooks/useQueryParams";
import useScreenName from "../../hooks/useScreenName";
import { ReactComponent as BusinessIcon } from "../../images/business.svg";
import { ReactComponent as UsersIcon } from "../../images/users.svg";
import EnterpriseUserScreen from "../enterprise-users";
import UserScreen from "../users";

type TabValue = "USERS" | "ENTERPRISES";

type QueryState = {
  tab: TabValue;
};

const DEFAULT_QUERY_STATE: QueryState = {
  tab: "USERS",
};

const tabItems: TabItem<TabValue>[] = [
  {
    label: "Users",
    value: "USERS",
    Icon: UsersIcon,
  },
  {
    label: "Enterprises",
    value: "ENTERPRISES",
    Icon: BusinessIcon,
  },
];

export default function Borrowers() {
  useScreenName("Borrowers");

  const [{ tab }, setSearchQuery] =
    useQueryParams<QueryState>(DEFAULT_QUERY_STATE);

  const handleTabChange = (newTab: TabValue) => {
    setSearchQuery({
      tab: newTab,
    });
  };

  return (
    <>
      <div className="dashboard-container p-3">
        <Tabs items={tabItems} value={tab} onChange={handleTabChange} />
      </div>

      <div>
        {tab === "USERS" && <UserScreen />}
        {tab === "ENTERPRISES" && <EnterpriseUserScreen />}
      </div>
    </>
  );
}
